import { render, staticRenderFns } from "./dispendios-icon.vue?vue&type=template&id=e660d602&"
import script from "./dispendios-icon.vue?vue&type=script&lang=js&"
export * from "./dispendios-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports